<template>
  <div class="view">
    <div class="flex-row">
      <div class="left">
        <h2>{{$t('discover.title')}}</h2>
        <p v-html="$t('discover.subtitle')"></p>
        <p v-html="$t('discover.tourism1')"></p>
        <p v-html="$t('discover.tourism2')"></p>
        <p v-html="$t('discover.tourism3')"></p>
      </div>
      <div class="right">
        <img src="@/assets/pont.jpg"/>
        <img src="@/assets/vins.jpg"/>
      </div>
    </div>
    <img class="compostelle" src="@/assets/compostelle.jpg" />
    <div class="flex-row">
      <div class="left">
        <h2>{{$t('discover.compostelle')}}</h2>
        <div v-html="$t('discover.content')"></div>
      </div>
      <div class="right">
        <img src="@/assets/carte-st-jacques.png"/>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Tourism'
}
</script>

<style lang="scss" scoped>
.compostelle {
  margin: 50px auto;
  width: 100px;
}
.flex-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 50px;
  align-items: space-between;
  justify-content: flex-start;
  box-sizing: border-box;
  @media (max-width: 500px) {
    padding: 0 10px;
  }
  .left  {
    flex: 3;
    width: calc(100% - 20px);
    h2 {
    text-align: left;
    }
    p, div {

      text-align: left;
      min-width: 300px;
      max-width: 100%;
      font-size: 22px;
      margin-bottom: 30px;
    }
  }
  // div {
  //   margin: 10px;
  // }
  .right {
    flex: 1;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      width: 100%;
      min-width: 250px;
      // max-width: 400px;
      // height: auto;
      margin-top: 10px;
      // margin: auto;
    }
  }
}
p.footer {
  margin-top: 100px;
  text-align: left;
}

</style>